module.exports = {
  defaultTitle: 'OUT OF FOCUS',
  defaultTitleEN: 'OUT OF FOCUS',
  author: 'OUT OF FOCUS',
  url: 'https://outoffocus.video',
  legalName: 'OUT OF FOCUS',
  defaultDescription: 'film, teledysk, zdjęcia, sesja, fotografia, Warszawa, Polska, reklama, usługi foto i wideo',
  defaultDescriptionEN:
    'film, music video, photos, session, photography, Warsaw, Poland, advertising, photo and video services',
  googleAnalyticsID: 'UA-156024874-1',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  contact: {
    email: 'kontakt@maxrec.pl',
    phone: '664205145',
  },
  foundingDate: '2020',
  recaptcha_key: '6LcOo9IUAAAAAA-0fl-6zp9jSrwwAMsOVMXwtY6j',
};
